import { render } from "./Login.vue?vue&type=template&id=8940732c"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__